module.exports = __webpack_public_path__ + "static/logo-58547d350705c86aa72b6b6d92449456.png";